import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { Usuario } from 'src/app/model/index.model';
import { firstValueFrom } from 'rxjs';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})

export class UsuarioService extends BaseService<Usuario> {

  constructor(protected override http: HttpClient) {
    super(http, 'usuario');
  }



  doLogin(user) {
    this.other_header = UturuncoUtils.getHeader();
    console.log(user)

    return firstValueFrom(this.http
      .post(this.api + "/custom/login", user, { headers: this.other_header })
    );
  }


  doRestorePass(usuario) {
    this.other_header = UturuncoUtils.getHeader();
    let body = {
      usuario: usuario,

    }
    return firstValueFrom(this.http
      .post(this.api + "/restore/user", body, { headers: this.other_header })
    );
  }

  doChangePass(id, oldClave, newClave) {
    this.other_header = UturuncoUtils.getHeader();
    let body = {
      id: id,
      oldClave: oldClave,
      newClave: newClave
    }
    return firstValueFrom(this.http
      .post(this.api + "/change/pass", body, { headers: this.other_header })
    );
  }


  doRefresh() {
    this.other_header = UturuncoUtils.getHeader();
    let body = {
      refresh: UturuncoUtils.getSession("refresh")
    }
    return firstValueFrom(this.http
      .post(this.api + "/refresh/user", body, { headers: this.other_header })
    );
  }

  doCompradores() {
    this.other_header = UturuncoUtils.getHeader();
    let body = {
      refresh: UturuncoUtils.getSession("refresh")
    }
    return firstValueFrom(this.http
      .post(this.api + "/refresh/user", body, { headers: this.other_header })
    );
  }
}